import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import MaterialTable from 'material-table';
import { Container } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';

import api from '../../../../../services/api.js';

import Add from './Components/Add.js'
import Del from './Components/Del.js'
import Edit from './Components/Edit.js'

export default function TableRecursoMaterial(props) {
    const tableRef = useRef();
    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [users, setUsers] = useState([]);
    // const [info, setInfo] = useState([]);

    const state = {
        columns: [
            {
                title: "Opções",
                field: "opcoes",
                render: (rowData) => {
                    return (
                        <div style={{ display: 'flex', alignitems: 'center' }}>
                            <Edit setData={props.setData} setOpen={props.setOpen} data={rowData} />
                            <Del setReload={props.setReload} data={rowData} />
                        </div>
                    )
                }
            },
            { title: "Equipamento/Recurso", field: "equipamento" },
            { title: "Cidade", field: "cidade" },
            { title: "Responsável", field: "responsavel" },
            { title: "Telefone", field: "telefone" },
            { title: "Celular", field: "celular" },
            { title: "Local", field: "local" },
        ],
    };

    useEffect(() => {
        async function fetchData() {
            api.get(`/contacts/resources`)
                .then((res) => {
                    setUsers(res.data)
                })
                .catch((error) => {
                    console.log(error);
                    snack.current("Falha ao buscar recursos", { variant: 'error' })
                });
        }
        fetchData();
    }, [props.reload]);


    return (
        <Container maxWidth={false} spacing={2}>
            <MaterialTable
                tableRef={tableRef}
                title="Recursos Materiais Próprios"
                columns={state.columns}
                data={users}
                options={{
                    search: true,
                    pageSize: 10,
                    exportButton: false,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [1, 5, 10, 20, users.length],
                    padding: "dense",
                    headerStyle: {
                        textAlign: "center",
                        color: "#b31b1b",
                    },
                    cellStyle: {
                        textAlign: "center",
                    },
                }}

                localization={{
                    body: {
                        emptyDataSourceMessage: "",
                        addTooltip: "adicionar novo",
                        deleteTooltip: "excluir",
                        editRow: { deleteText: "Deseja excluir?" },
                    },

                    header: {
                        actions: "Opções",
                    },

                    toolbar: {
                        searchTooltip: "Pesquisar",
                        searchPlaceholder: "Pesquisar",
                        exportTitle: "exportar",
                        nRowsSelected: "{0} Usuários(s) selecionados",
                    },
                    pagination: {
                        labelRowsSelect: "",
                        labelDisplayedRows: "{count} de {from}-{to}",
                        firstTooltip: "Primeira página",
                        previousTooltip: "Página anterior",
                        nextTooltip: "Próxima página",
                        lastTooltip: "Última página",
                    },
                }}
                components={{
                    Actions: () => {
                        return (
                            <Add setData={props.setData} setOpen={props.setOpen} />
                        );
                    }
                }}
            />
        </Container >
    );
}

TableRecursoMaterial.propTypes = {
    reload: PropTypes.bool,
    setData: PropTypes.func,
    setOpen: PropTypes.func,
    setReload: PropTypes.func,
    setAffiliates: PropTypes.func,
};
